var map = {
	"./bnwstar.svg": 59115,
	"./collection-banner.jpg": 84556,
	"./home.jpg": 50350,
	"./icon-editor": 43314,
	"./icon-editor.js": 43314,
	"./logo.png": 74427,
	"./logo@2x.png": 45745,
	"./logo@3x copy.png": 94961,
	"./logo@3x.png": 41814,
	"./star-empty.svg": 48105,
	"./star-half.svg": 77898,
	"./web-nav.png": 99294,
	"./web-nav@2x.png": 29165,
	"./web-nav@3x.png": 50629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;